<template>
  <div>
    <el-button @click="showDialog">添加物料</el-button>
    <el-button :disabled="tableData.length === 0" @click="createTicket">下达{{ checkDate() }}</el-button>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"/>
      <el-table-column prop="name" label="物料名称" width="200"></el-table-column>
      <el-table-column prop="image" label="图片" width="80">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" v-if="scope.row.image">
            <img :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 500px; height: 500px"/>
            <img slot="reference" :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 40px; height: 40px"/>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="typeName" label="物料类型"width="200"></el-table-column>
      <el-table-column prop="num" label="数量"width="200"/>
      <el-table-column prop="producibleQuantity" label="可生产数量"width="200"/>
      <el-table-column prop="warehouseName" label="所属仓库"/>
      <el-table-column label="单价">
        <template slot-scope="scope">
          <el-input-number style="width: auto" v-model="scope.row.price" placeholder="请输入单价"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="useNum" label="需求数量">
        <template slot-scope="scope">
          <el-input-number style="width: auto" v-model="scope.row.useNum" placeholder="请输入需求数量"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteMaterial(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加物料" :visible.sync="dialogVisible" width="30%">
      <MaterialLov width="300px" @callBack="setMaterialNew"/>
      <el-button @click="addMaterial">确定</el-button>
    </el-dialog>
    <el-dialog title="物料详情" :visible.sync="showProcessable" destroy-on-close width="30%">
      <el-table :data="processableTableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="80"/>
        <el-table-column prop="name" label="物料名称" width="200"/>
        <el-table-column prop="typeName" label="物料类型" width="100"/>
        <el-table-column prop="num" label="总数量" width="100"/>
        <el-table-column prop="usedNum" label="已占用数量" width="100"/>
        <el-table-column prop="freeNum" label="空闲数量" width="100"/>
        <el-table-column prop="image" label="图片" width="80">
          <template slot-scope="scope">
            <el-popover placement="right" trigger="hover" v-if="scope.row.image">
              <img :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 500px; height: 500px"/>
              <img slot="reference" :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 40px; height: 40px"/>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName" width="100" label="所属仓库"/>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import MaterialLov from "@/views/ticket/lov/MaterialLov.vue";
import requestTicket from "@/utils/requestTicket";
import ScreenTableHeader from "@/views/element/ScreenTableHeader.vue";

export default {
  name: "Sale",
  components: {ScreenTableHeader, MaterialLov},
  data() {
    return {
      tableData: [],
      processableTableData: [],
      dialogVisible: false,
      showProcessable: false,
      __materialNew: null,
      // 添加相关数据字段以匹配Process.vue中的逻辑
      typeId: 20, // 销售单类型ID
      processIndex: null,
      typeHead: [],
      typeLineHead: [],
      columns: [],
      columnLines: [],
      processId: null
    };
  },
  mounted() {
  },
  methods: {
    setMaterialNew(material) {
      this.__materialNew = material;
    },
    async addMaterial() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_with_num",
          parameters: [null]
        });
        const __data = response.data.find(item => item.id === this.__materialNew.id);
        if (__data) {
          __data.producibleQuantity = await this.getProducibleQuantity(__data);
          this.tableData.push(__data);
          this.dialogVisible = false;
        } else {
          console.log("没有找到该物料");
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
    // 添加删除物料方法
    deleteMaterial(index) {
      this.tableData.splice(index, 1);
      console.log("showDialog")
    },
    checkDate() {
      const __data1 = this.tableData.filter(item => item.useNum > item.num)
      if (__data1.length > 0) {
        return "预售单"
      } else {
        const __data2 = this.tableData.filter(item => item.useNum > (item.num + item.producibleQuantity))
        if (__data2.length > 0) {
          return "采购单"
        } else {
          return "销售单"
        }
      }
    },
    async getProducibleQuantity(item) {
      try {
        const response = await requestTicket.post('/Ticketing/saleUtil/producibleQuantity', item.id)
        const __data = response.data;
        if (__data) {
          return __data
        } else {
          return 0
        }
      } catch (error) {
        return 0;
      }
    },
    // 初始化单据类型和表头数据
    async initTicketData(ticketType) {
      try {
        // 获取单据流程列表
        const processRes = await requestTicket.post('/Ticketing/ticket-process/findAll');
        const processList = processRes.data.filter(item => item.type_id === ticketType);
        // 取得process_index最小的流程
        this.processIndex = processList.reduce((min, item) => item.processIndex < min ? item.processIndex : min, processList[0].processIndex);
        this.processId = processList.reduce((min, item) => item.processIndex < min ? item.processIndex : min, processList[0].processId);
        
        // 获取表头信息
        const headRes = await requestTicket.post('/Ticketing/ticket-head/findAll');
        this.typeHead = headRes.data;
        
        // 获取子表表头信息
        const lineHeadRes = await requestTicket.post('/Ticketing/ticket-line-head/findAll');
        this.typeLineHead = lineHeadRes.data;
        
        // 根据单据类型获取表头字段
        this.columns = this.typeHead.filter(item => 
          item.typeId === ticketType &&
          item.process && 
          item.process.split(',').includes(this.processId.toString())
        );
        
        // 根据单据类型获取子表表头字段
        this.columnLines = this.typeLineHead.filter(item => 
          item.typeId === ticketType &&
          item.process && 
          item.process.split(',').includes(this.processId.toString())
        );
      } catch (error) {
        console.error('初始化单据数据失败:', error);
        throw error;
      }
    },
    async createTicket() {
      const __data = this.tableData.filter(item => item.useNum > item.num)
      if (__data.length > 0) {
        const __data2 = this.tableData.filter(item => item.useNum > (item.num + item.producibleQuantity))
        if (__data2.length > 0) {
          // 同时创建采购单
        }
        // 创建预售单
        await this.createPresale()
        // 创建预售物料
        await this.createPresaleMaterial()
        return
      } else {
        // 创建销售单
        await this.createSaleTicket();
      }
    },
    // 创建销售单据
    async createSaleTicket() {
      try {
        // 初始化单据数据
        await this.initTicketData(10);
        // 构造主表数据
        const ticketData = this.createTicketData();
        
        // 保存主表数据
        const ticketRes = await requestTicket.post('/Ticketing/ticket/save', ticketData);
        
        if (ticketRes.data && ticketRes.data.id) {
          // 构造并保存历史记录
          const ticketHisData = this.createTicketHisData({
            ...ticketRes.data,
            tickedId: ticketRes.data.id,
            processId: this.processId,
            processIndex: this.processIndex
          });
          
          await requestTicket.post('/Ticketing/ticket-his/save', ticketHisData);
          
          // 构造并保存子表数据
          for (const item of this.tableData) {
            const lineData = this.createTicketLineData(item, ticketRes.data.id);
            await requestTicket.post('/Ticketing/ticket-line/save', lineData);
            
            // 保存子表历史记录
            const lineHisData = {
              ...lineData,
              ticketLineId: lineData.id,
              processId: this.processId,
              processIndex: this.processIndex
            };
            await requestTicket.post('/Ticketing/ticket-line-his/save', lineHisData);
          }
          
          this.$message.success('销售单创建成功');
        }
      } catch (error) {
        console.error('创建销售单失败:', error);
        this.$message.error('创建销售单失败');
      }
    },
    // 构造主表数据（参考Process.vue中的createTicket方法）
    createTicketData() {
      // 根据columns动态构造数据
      const ticket = {
        ticketType: this.typeId
      };
      
      // 根据配置的列和tableDate动态添加字段
      this.columns.forEach(col => {
        ticket[col.prop] = this.formData[col.prop];
      });
      
      return ticket;
    },
    // 构造主表历史数据（参考Process.vue中的createTicketHis方法）
    createTicketHisData(row) {
      const ticketHis = {
        tickedId: row.tickedId,
        processId: row.processId,
        processIndex: row.processIndex,
        ticketType: row.ticketType
      };
      
      // 根据columns动态添加字段
      this.columns.forEach(col => {
        if (row[col.prop] !== undefined) {
          ticketHis[col.prop] = row[col.prop];
        }
      });
      
      return ticketHis;
    },
    // 构造子表数据
    createTicketLineData(item, ticketId) {
      const line = {
        ticketId: ticketId
      };
      
      // 根据columnLines动态添加字段
      this.columnLines.forEach(col => {
        switch (col.prop) {
          case 'materialId':
            line[col.prop] = item.id;
            break;
          case 'materialName':
            line[col.prop] = item.name;
            break;
          case 'quantity':
            line[col.prop] = item.useNum;
            break;
          case 'price':
            line[col.prop] = item.price;
            break;
          case 'amount':
            line[col.prop] = item.useNum * item.price;
            break;
          default:
            line[col.prop] = null;
        }
      });
      
      return line;
    },
    // 创建预售物料
    async createPresaleMaterial() {
      const __param = this.tableData.map(item => {
        return {
          material_id: item.id,
          batch: '',
          price: item.price,
          num: item.useNum ,
          saled: 1,
          description: '预售物料，不计入库存'
        }
      })
      try {
        for (let param of __param) {
          await requestTicket.post('/Ticketing/material-item/save', param)
        }
      } catch (error) {
        console.error('创建预售物料失败:', error);
      }
    },
    // 创建预售单
    async createPresale() {
      // ticket_type = 20
      // 取ticket_type = 20 的 process最小的ticket_process数据
      // 取ticket_type = 20 的 process = ticket_process.id 的 process_head,
    },
    // 创建生产单
    async createTicketToDo() {

    }
  }
}
</script>
<style scoped>

</style>